import setCurrentPage from "src/Utils/setCurrentPage";
import store from "src/Reducers/store";
import ConversationEffect from "src/Animations/ConversationEffect";

const previousPage = () => store.getState().appReducer.previousPage;

export const DATA_TRANSPORT_NETWORK_INLCM_1 = {
  title: `<span style="color: #BEE3FF;">Configuration and management of the\n transport network devices</span>\n\nPopulate the state and site information \nfrom the order and locate the device \ntype and model that needs to be created \nfrom the device palette using drag and \ndrop.`,
  subtitle: "Transport Network",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ENG_323"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(previousPage()),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ENG/INLCM/INLCM_dark_bg_2.png",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "ENG/INLCM/INLCM_digital_twin_01_computer.png",
          effect: "animate-opacity",
          imageStyle: { position: "absolute", bottom: "160px", right: "0px" },
        },
        {
          image: "ENG/INLCM/INLCM_transport_net_01_popup.png",
          imageStyle: { position: "absolute", bottom: "328px", right: "103px" },
        },
      ]}
      pageNumber={"ENG_322"}
    />
  ),
};
